import { styled } from 'shared/ui';

export const Item = styled('li', ({ $theme }) => ({
  border: `1px solid ${$theme.colors.gray200}`,
  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
  borderRadius: '8px',
}));
